import React, { Component } from 'react';
import { Row, Col } from 'antd';
import resources from '../resources';

import languages from '../appdata/languages';
import StoreManager from '../appdata';

class Awards extends Component {
  renderAwardItem = (item, index) => {
    const isEven = index % 2 === 0;
    const isMobile = window.innerWidth < 768;

    return (
      <Row
        key={index}
        gutter={[24, 48]}
        align="stretch" // ✅ đảm bảo 2 Col có cùng chiều cao
        style={{
          marginBottom: 48,
          flexDirection: isMobile ? 'column' : isEven ? 'row' : 'row-reverse',
          alignItems: isMobile ? 'left' : 'stretch' // ✅ stretch để ảnh bám đầy chiều cao
        }}
      >
        {/* IMAGE COLUMN */}
        <Col xs={24} md={10} style={{ display: 'flex' }}>
          <div style={{ flex: 1 }}>
            <img
              src={resources.images[`AwardImage${index + 1}`]}
              alt={item.title}
              style={{
                width: '100%',
                height: isMobile ? 220 : '100%', // ✅ chiếm toàn bộ chiều cao col
                objectFit: 'cover',
                borderRadius: 12,
              }}
            />
          </div>
        </Col>


        {/* TEXT COLUMN */}
        <Col xs={24} md={14}>
          <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 20, color: '#111' }}>
            {item.title}
          </h3>
          <ul style={{ paddingLeft: 0, listStyle: 'none', margin: 0 }}>
            {item.awards.map((award, i) => (
              i % 2 === 0 && ( // chỉ render khi index là chẵn
                <li key={i} style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                  <div style={{
                    width: 20,
                    height: 20,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: 6,
                  }}>
                    <img src={resources.icons.AwardIcon} alt="icon" style={{ width: 20, height: 24, objectFit:'contain' }} />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                    <span style={{
                      fontSize: 16,
                      lineHeight: '22px',
                      color: '#212121',
                      fontWeight: 600,
                    }}>
                      {award}
                    </span>
                    {item.awards[i + 1] && (
                      <span style={{
                        fontSize: 16,
                        lineHeight: '20px',
                        color: '#858585',
                        fontWeight: 400,
                        marginTop: 2,
                      }}>
                        {item.awards[i + 1]}
                      </span>
                    )}
                  </div>
                </li>
              )
            ))}
          </ul>
        </Col>
      </Row>
    );
  };


  render() {
    const lg = StoreManager.appState.thisApp.state.currentLanguage;
    const lang = languages[lg].AwardsContent;

    return (
      <div style={{ backgroundColor: '#fff', padding: '80px 24px' }}>
        <div style={{ maxWidth: 1040, margin: '0 auto' }}>
          <h2 style={{ fontSize: 32, fontWeight: 700, marginBottom: 48, color: '#111' }}>
            {lang.title}
          </h2>
          {lang.sections.map(this.renderAwardItem)}
        </div>
      </div>
    );
  }
}

export default Awards;

